"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _createSvgIcon = _interopRequireDefault(require("../utils/createSvgIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = (0, _createSvgIcon["default"])( /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M27.55,3.8a1.6,1.6,0,0,0-1.41-.88H5.86a1.6,1.6,0,0,0-1.41.88,1.82,1.82,0,0,0,0,1.64L10.28,19v9.42a.65.65,0,0,0,.65.65H21.07a.66.66,0,0,0,.66-.65V19L27.57,5.47A1.85,1.85,0,0,0,27.55,3.8ZM26.39,4.92,20.48,18.61a.58.58,0,0,0-.06.26v8.91H17a1.73,1.73,0,0,0,.14-.66c0-.72-.41-1.31-.91-1.31s-.92.59-.92,1.31a1.73,1.73,0,0,0,.14.66H11.58V18.87a.58.58,0,0,0-.06-.26L5.6,4.89a.51.51,0,0,1,0-.48.31.31,0,0,1,.26-.19H26.14a.31.31,0,0,1,.26.19A.54.54,0,0,1,26.39,4.92Z"
}), /*#__PURE__*/_react["default"].createElement("circle", {
  cx: "10.4",
  cy: "7.23",
  r: "1.09"
}), /*#__PURE__*/_react["default"].createElement("circle", {
  cx: "14.77",
  cy: "10.72",
  r: "1.09"
}), /*#__PURE__*/_react["default"].createElement("circle", {
  cx: "17.09",
  cy: "6.58",
  r: "1.09"
}), /*#__PURE__*/_react["default"].createElement("circle", {
  cx: "19.56",
  cy: "13.12",
  r: "1.09"
}), /*#__PURE__*/_react["default"].createElement("circle", {
  cx: "21.75",
  cy: "9.63",
  r: "1.09"
}), /*#__PURE__*/_react["default"].createElement("circle", {
  cx: "11.49",
  cy: "14.86",
  r: "1.09"
}), /*#__PURE__*/_react["default"].createElement("circle", {
  cx: "15.86",
  cy: "16",
  r: "1.09"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M14.06,21.15c0-.73-.41-1.31-.92-1.31s-.91.58-.91,1.31.41,1.3.91,1.3S14.06,21.87,14.06,21.15Z"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M16,18.29c-.51,0-.92.59-.92,1.31s.41,1.31.92,1.31.92-.59.92-1.31S16.51,18.29,16,18.29Z"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M16,21.93c-.51,0-.92.58-.92,1.3s.41,1.31.92,1.31.92-.58.92-1.31S16.51,21.93,16,21.93Z"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M18.47,19.6c-.51,0-.92.59-.92,1.31s.41,1.3.92,1.3.91-.58.91-1.3S19,19.6,18.47,19.6Z"
}), /*#__PURE__*/_react["default"].createElement("ellipse", {
  cx: "18.47",
  cy: "24.54",
  rx: "0.92",
  ry: "1.31"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M13.68,23.79c-.51,0-.92.59-.92,1.31s.41,1.31.92,1.31.91-.59.91-1.31S14.18,23.79,13.68,23.79Z"
})));
module.exports = exports.default;